<script lang="ts">
import { siWikipedia } from "simple-icons";
import SimpleIcon from "./SimpleIcon.svelte";

let { class: className }: { class?: string } = $props();
</script>

<SimpleIcon icon={siWikipedia} class={className} />
